module.exports = __webpack_public_path__ + "static/media/Motor.2dc0cb3b.mp3";